import callApi from '../../util/apiCaller';
import async from 'async';
import isEmpty from 'lodash/isEmpty';
// import { userNotify } from '../../components/Toasts/ToastAdd';
import { setPageNotFound } from './AppActions';

//RealEvent Search Page
export const SET_REALEVENT_SEARCH_PAGE_FILTERS = 'SET_REALEVENT_SEARCH_PAGE_FILTERS';
export const SET_REALEVENT_SEARCH_APPLIED_FILTERS = 'SET_REALEVENT_SEARCH_APPLIED_FILTERS';
export const FETCHING_REALEVENTS = 'FETCHING_REALEVENTS';
export const FETCH_REALEVENTS = 'FETCH_REALEVENTS';
export const SET_REALEVENT_FILTER = 'SET_REALEVENT_FILTER';
export const SET_REALEVENT_FILTER_ITEM = 'SET_REALEVENT_FILTER_ITEM';
export const SET_MIN_MAX_REALEVENT_FILTER_ITEM = 'SET_MIN_MAX_REALEVENT_FILTER_ITEM';
export const SET_REALEVENT_SORT_FILTERS = 'SET_REALEVENT_SORT_FILTERS';

export const SET_REALEVENT_FILTERS = 'SET_REALEVENT_FILTERS';
export const FETCHING_REALEVENT_FILTERS = 'FETCHING_REALEVENT_FILTERS';
export const FETCH_REALEVENT_FILTERS = 'FETCH_REALEVENT_FILTERS';
export const APPLY_FILTERS = 'APPLY_FILTERS';
export const APPLYING_FILTERS = 'APPLYING_FILTERS';
export const OPEN_FILTERS_MODAL = 'OPEN_FILTERS_MODAL';
export const CLOSE_FILTERS_MODAL = 'CLOSE_FILTERS_MODAL';
export const SET_OCCASION_FILTERS = 'SET_OCCASION_FILTERS';
export const SET_COLOR_FILTERS = 'SET_COLOR_FILTERS';
export const SET_CITY_FILTERS = 'SET_CITY_FILTERS';
export const SET_SUBAREA_FILTERS = 'SET_SUBAREA_FILTERS';
export const SET_EVENTTIME_FILTERS = 'SET_EVENTTIME_FILTERS';

//Event Page
export const LOADING_REALEVENT_PAGE = 'LOADING_REALEVENT_PAGE';
export const LOAD_REALEVENT_PAGE = 'LOAD_REALEVENT_PAGE';
export const FETCH_MORE_REALEVENTS = 'FETCH_MORE_REALEVENTS';

export function showLoaderForRealEvents() {
  return {
    type: FETCHING_REALEVENTS,
    isFetchingRealEvents: true,
  };
}

export function loadRealEvents(data) {
  return {
    type: FETCH_REALEVENTS,
    isFetchingRealEvents: false,
    list: data.realevents,
    totalCount: data.totalCount,
    pageNum: data.pageNum,
    searchValidators: data.searchValidators,
  };
}


export function getMoreRealEventsForSearch(query, page) {
  let url = `realevents/list-page`;
  if (query && query !== '') {
    url = `${url}${query}&page=${page}`;
  } else {
    url = `${url}?page=${page}`;
  }
  return (dispatch) => {
    // dispatch(showLoaderForRealEvents());
    return callApi(url, 'get')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadMoreRealEvents(res.data));
        } else {
          // dispatch(userNotify('Failed to load real events.Please try again.', 'error'));
          // dispatch(sendNewsletterFailedResponse());
        }
      });
  };
}

export function loadMoreRealEvents(data) {
  return {
    type: FETCH_MORE_REALEVENTS,
    isFetchingRealEvents: false,
    list: data.realevents,
    totalCount: data.totalCount,
    pageNum: data.pageNum,
  };
}
export function showLoaderForRealEventPage() {
  return {
    type: LOADING_REALEVENT_PAGE,
    isLoadingRealEventPage: true,
  };
}

export function loadRealEventPage(data) {
  return {
    type: LOAD_REALEVENT_PAGE,
    isLoadingRealEventPage: false,
    realevent: data.realevent,
    images: data.images,
    similarRealEvents: data.similarRealEvents,
  };
}

export function getRealEventsForSearch(query) {
  let url = `realevents/list-page`;
  if (query && query !== '') {
    url = `${url}${query}`;
  }
  return (dispatch) => {
    dispatch(showLoaderForRealEvents());
    return callApi(url, 'get')
      .then(res => {
          if (res.status === 'Success') {
            if (!isEmpty(res.data)) {
              dispatch(loadRealEvents(res.data));
            } else {
              dispatch(setPageNotFound(true));
            }
          }
        },
      );
  };
}

export function loadRealEventFilters(data) {
  let filters = data && data.filters && data.filters.length > 0 ? data.filters.filter(item => item.isFilterVisible) : [];
  let realeventSearchParams = [];
  filters.forEach(item => {
    if (item.filterType !== 'dropDown') {
      realeventSearchParams.push({
        paramType: item.filterType,
        paramName: item.queryParamName,
      });
    } else {
      realeventSearchParams.push({
        paramType: item.filterType,
        minParamName: item.minQueryParamName,
        maxParamName: item.maxQueryParamName,
      });
    }
  });
  return {
    type: SET_REALEVENT_FILTERS,
    isBaseFiltersLoaded: true,
    realeventSearchFilters: filters,
    sortFilters: data.sortsets,
    realeventSearchParams: realeventSearchParams,
  };
}

export function getRealEventsFilters() {
  return (dispatch) => {
    return callApi(`realevents/base-params`, 'get')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadRealEventFilters(res.data));
        }
      });
  };
}

export function fetchRealEventByUrl(url) { 
 return (dispatch) => {
    dispatch(showLoaderForRealEventPage());
    return callApi(`realevents/page/${url}`, 'get')
      .then(res => {
        if (res.status === 'Success') {
          if (isEmpty(res.data.realevent)) {
            let data = {
              realevent: {
                isNull: true,
              },
            };
            dispatch(loadRealEventPage(data));
          } else {
            dispatch(loadRealEventPage(res.data));
          }
        } else {
          // dispatch(userNotify('Failed to load real events.Please try again.', 'error'));
        }
      });
  };
}

export function fetchRealEventList(filters) {
  return (dispatch) => {
    dispatch(showLoaderForRealEventListPage());
    return callApi(`realevents/list-page`, 'post')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadRealEventPage(res.data));
        } else {
          // dispatch(userNotify('Failed to load real events.Please try again.', 'error'));
          // dispatch(sendNewsletterFailedResponse());
        }
      });
  };
}

export function showLoaderForRealEventsListPage() {
  return {
    type: LOADNG_LISTPAGE,
    isLoadingListPage: true,
    isFetchingRealEvents: true,
  };
}

export function setRealEventMinMaxFilterItem(paramName, value) {
  return {
    type: SET_MIN_MAX_REALEVENT_FILTER_ITEM,
    paramName: paramName,
    value: value,
  };
}

export function setEventTimeFilters(val, isSelected) {
  return (dispatch) => {
    dispatch({
      type: SET_EVENTTIME_FILTERS,
      value: val,
      isSelected: isSelected,
    });
  };
}

export function setCityFilters(val, isSelected) {
  return (dispatch) => {
    dispatch({
      type: SET_CITY_FILTERS,
      value: val,
      isSelected: isSelected,
    });
  };
}

export function setSubAreaFilters(val, isSelected) {
  return (dispatch) => {
    dispatch({
      type: SET_SUBAREA_FILTERS,
      value: val,
      isSelected: isSelected,
    });
  };
}

export function setOccasionsFilters(val, isSelected) {
  return (dispatch) => {
    dispatch({
      type: SET_OCCASION_FILTERS,
      value: val,
      isSelected: isSelected,
    });
  };
}

export function setColorFilters(val, isSelected) {
  return (dispatch) => {
    dispatch({
      type: SET_COLOR_FILTERS,
      value: val,
      isSelected: isSelected,
    });
  };
}

export function applyRealEventFilters() {
  return (dispatch) => {
    dispatch({
      type: APPLYING_FILTERS,
      isFilterApplied: true,
    });
  };
}

export function resetRealEventFilters() {
  return (dispatch) => {
    dispatch({
      type: RESET_FILTERS,
      isFetchingFilters: false,
    });
  };
}

export function showFilterModal() {
  return (dispatch) => {
    dispatch({
      type: OPEN_FILTERS_MODAL,
      isFetchingFilters: true,
    });
  };
}

export function resetFilterModal() {
  return (dispatch) => {
    dispatch({
      type: CLOSE_FILTERS_MODAL,
      isFetchingFilters: false,
    });
  };
}

export function firstPageLoad() {
  let model = {};
  return (dispatch) => {
    dispatch(showLoaderForRealEventsListPage());
    async.series([
      (cb) => {
        callApi(`realevents/list`, 'post', {
          filters: {},
        })
          .then(res => {
            if (res.status === 'Success') {
              model.realevent;
            } else {
              // dispatch(userNotify('Failed to load real events.Please try again.', 'error'));
              // dispatch(sendNewsletterFailedResponse());
            }
          });
      },
      function (cb) {
        callApi(`realevents/list`, 'post', {
          filters: filters,
        })
          .then(res => {
            if (res.status === 'Success') {
              dispatch(sendRealEventsFromApi(res.data.realevents));
            } else {
              // dispatch(userNotify('Failed to load real events.Please try again.', 'error'));
              // dispatch(sendNewsletterFailedResponse());
            }
          });
      },
    ], function (err) {
      if (model.realevent.isApproved) {

      } else {

      }
    });
  };
}

export function setRealEventAppliedFilters(filters) {
  return (dispatch) => {
    dispatch({
      type: SET_REALEVENT_SEARCH_APPLIED_FILTERS,
      appliedFilters: filters,
    });
  };
}

export function setRealEventFilterItem(paramName, value) {
  return {
    type: SET_REALEVENT_FILTER_ITEM,
    paramName: paramName,
    value: value,
  };
}

export function setRealEventFilter(paramName, value, isSelected) {
  return {
    type: SET_REALEVENT_FILTER,
    paramName: paramName,
    value: value,
    isSelected: isSelected,
  };
}

export function setNewRealEventFilters(filters) {
  return (dispatch) => {
    dispatch({
      type: SET_REALEVENT_SEARCH_PAGE_FILTERS,
      realeventSearchFilters: filters,
    });
  };
}

export function setRealEventSortFilters(sortFilters) {
  return {
    type: SET_REALEVENT_SORT_FILTERS,
    sortFilters: sortFilters
  };
}

